<template>
  <div class="filter-search">
    <div
      class="filter"
      v-for="(f,index) in filters"
      :key="index">
      <div class="filter-item">
        <el-select class="select-input" multiple collapse-tags v-model="searchForm[f.code]" value-key="code" :placeholder="f.label" @change="(value)=>selectProperty(f,value)">
          <el-option
              v-for="(v,i) in f.values"
              :key="i"
              :label="v.name"
              :value="v"
          />
        </el-select>
      </div>
    </div>
    <div class="filter">
      <div class="filter-item">
        <el-select class="select-input" v-model="productSeries" value-key="id" placeholder="产品系列" @change="(value)=>selectSeries(value)">
          <el-option
              v-for="(v,i) in aggProductSeries"
              :key="i"
              :label="v.name"
              :value="v"
          />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { switchDataType } from '@/assets/js/dict'
export default {
  name: 'FilterSearch',
  props: {
    searchProperties: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      searchForm: {},
      productSeries: '',
      filters: [],
      propertyParams: [],
      selectSeriesParams: [],
      hasSeriesParams: false,
      dataCurrent: [{ code: 'V000023', name: '屋顶风机' }]
    }
  },
  computed: {
    ...mapGetters({
      aggProductSeries: 'list/aggProductSeries',
      initPropertySearchValue: 'fastSearch/initPropertySearchValue',
      propertySearchValues: 'fastSearch/propertySearchValues',
      selectionParams: 'selectionParams'
    }),
    showProductSeries() {
      return !this.productSeries && this.aggProductSeries.length
    },
    showComponent() {
      return this.showProductSeries || this.filters.some((f) => f.show)
    }
  },
  created() {
  },
  mounted() {
    localStorage.setItem('isSelect', '0')
  },
  watch: {
    searchProperties: {
      handler(newVal) {
        const properties = [...newVal]
        const keys = Object.keys(this.searchForm)
        const handledProperties = properties.map((p) => {
          const hasSearched = keys.includes(p.code)
          return {
            ...p,
            show: !hasSearched
          }
        })
        this.filters = [...handledProperties]
      },
      immediate: true
    },
    initPropertySearchValue: {
      handler(newVal) {
        // P000002 P000003 P000006 P000046
        this.searchForm = { ...newVal }
        // this.searchForm.P000002 = [{ code: 'V000023', name: '屋顶风机' }]
      },
      immediate: true
    },
    showComponent: {
      handler(newVal) {
        // 在父组件中控制是否展示该组件
        this.$emit('change', newVal)
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations({
      setSelectionParams: 'setSelectionParams',
    }),
    // 多选下拉组件
    selectProperty(f, v) {
      localStorage.setItem('isSelect', '1')

      const propertyParams = []
      if (v.length === 0) {
        propertyParams.push({
        // ...f,
          code: f.code,
          label: f.label,
          parameterType: switchDataType(f.dataType),
          queryType: 'ENUM',
          valueCode: null,
          valueName: null,
        })
      } else {
        v.forEach((v) => {
          propertyParams.push({
            // ...f,
            code: f.code,
            label: f.label,
            parameterType: switchDataType(f.dataType),
            queryType: 'ENUM',
            valueCode: v.code,
            valueName: v.name,
          })
        })
      }
      this.$emit('select', propertyParams)
    },
    // 产品系列下拉
    selectSeries(v) {
      this.selectSeriesParams = {
        label: '产品系列',
        code: 'productSeries',
        valueName: v.name,
        valueCode: v.id,
      }
      this.hasSeriesParams = true
      localStorage.setItem('isSelect', '1')
      this.$emit('select', this.selectSeriesParams)
    },
    // Tab删除
    updateSearchForm(property) {
      if (property.code === 'productSeries') {
        this.productSeries = null
        this.hasSeriesParams = false
        this.selectSeriesParams = []
      } else if (this.searchForm[property.code]) {
        this.searchForm[property.code] = this.searchForm[property.code].filter((v) => v.code !== property.valueCode)
      }
    },
    // 清空
    resetSearchForm() {
      this.productSeries = null
      this.hasSeriesParams = false
      this.propertyParams = []
      this.selectSeriesParams = []
      this.searchForm = {}
      this.setSelectionParams([])
    },
  },
}
</script>
<style lang='less' scoped>
.filter-search{
  display: flex;
}
.filter:not(:last-child){
  margin-right: 10px;
}
.filter-item{
  /deep/ .el-input__inner::placeholder{
    color: @theme-text-main;
  }
  /deep/ .el-input__inner {
    padding-right: 10px !important;
    padding: 0 20px 0 15px;
    border: 1px solid #DCDFE6;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: normal;
    white-space: nowrap;
  }
  .select-input{
    width: 190px;
  }
}
</style>
